var map = {
	"./gallery001.jpeg": 2701,
	"./gallery002.jpeg": 2747,
	"./gallery003.jpeg": 9463,
	"./gallery004.jpeg": 5300,
	"./gallery005.jpeg": 345,
	"./gallery006.jpeg": 3536,
	"./gallery007.jpeg": 2690,
	"./gallery008.jpeg": 8418,
	"./gallery009.jpeg": 2453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1641;